import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect, useContext } from 'react'
import Modal from 'react-modal';
import { Context } from '../../..';
import UserService from '../../../services/UserService';
import { ModalPopover } from './modal-popover';


const Organization: FC<any> = observer(data => {
    const { organization, index, setDelId, setDelModal } = data;

    return (
        <tr>
            <th scope="row">{index + 1}</th>
            <td>{organization['organization']}</td>
            <td><i className='icon trash' onClick={() => { setDelId(organization['id']); setDelModal(true) }} /></td>
        </tr>
    )
});


interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const OrganizationsListModal: FC<ModalProps> = observer(props => {
    const { toggle, setToggle } = props;
    const { store } = useContext(Context)
    const [organizations, setOrganizations] = useState<[]>([]);
    const [fix, setFix] = useState(true);
    const [delId, setDelId] = useState<number>(-1);
    const [delModal, setDelModal] = useState<boolean>(false);

    const getOrganizations = async () => {
        const res = await UserService.getOrganizations('');
        setOrganizations(res.data.results);
    };

    useEffect(() => {
        getOrganizations();
        setFix(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fix]);

    const onRequestClose = () => {
        setToggle(false);
    };

    const getOrgs = () => organizations.map((organization: any, index: number) => {
        return <Organization key={organization['id']} {...{ organization, index, setDelId, setDelModal }} />
    })

    const deleteOrg = async () => {
        await UserService.deleteOrganization(delId);
        setFix(true);
        setDelId(-1);
        setDelModal(false);
    }

    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <span className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
            </div>
            <form className="Modal__Body">
                <div className="form-group mb-3">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="co-md-1">№</th>
                                <th scope="col-md-3">Организация</th>
                                <th scope="col-md-2">Управление</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getOrgs()}
                        </tbody>
                    </table>

                </div>
                <ModalPopover
                    toggle={delModal}
                    setToggle={setDelModal}
                    title={store.lang === 'ba' ? 'Һөнәрҙе алып ташлау' : store.lang === 'ru' ? 'Удаление организации' : 'Deleting a organization'}
                    modalContent={<Trans>Do you want to delete a organization?</Trans>}
                    clickedButtonOne={() => deleteOrg()}
                    clickedButtonTwo={() => { setDelModal(false); setDelId(-1); }}
                    ButtonOneValue={store.lang === 'ba' ? 'Эйе' : store.lang === 'ru' ? 'Да' : 'Yes'}
                    ButtonTwoValue={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
                />
            </form>
        </Modal >
    );
});